/**
 * Button Component
 * Reusable button with primary/secondary variants and hover animations
 * @component
 */

import React from 'react';
import { ButtonProps } from '../types';

export const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  href,
  variant = 'primary',
  className = '',
  external = false,
}) => {
  const baseStyles = 'font-bold py-3 px-8 rounded-full transition-all transform hover:scale-105 duration-300 shadow-lg inline-flex items-center justify-center';
  
  const variantStyles = {
    primary: 'bg-green-600 text-white hover:bg-green-500 shadow-green-600/20',
    secondary: 'bg-gray-700 text-white hover:bg-gray-600 shadow-gray-700/20',
  };

  const combinedStyles = `${baseStyles} ${variantStyles[variant]} ${className}`;

  if (href) {
    return (
      <a
        href={href}
        className={combinedStyles}
        onClick={onClick}
        target={external ? '_blank' : undefined}
        rel={external ? 'noopener noreferrer' : undefined}
      >
        {children}
        {external && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 ml-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
            />
          </svg>
        )}
      </a>
    );
  }

  return (
    <button type="button" className={combinedStyles} onClick={onClick}>
      {children}
    </button>
  );
};
